import {defaultSelectedLeadership} from "./state";

export function setLeaderships(state, leaderships) {
	state.leaderships = leaderships;
}

export function setLeadership(state, leadership) {
	state.selectedLeadership = leadership
}

export function setAction(state, action) {
	state.action = action;
}

export function resetSelectedLeadership(state) {
	Object.assign(state.selectedLeadership, defaultSelectedLeadership())
}

export function setUsers(state, users) {
    state.users = users
}



// WEBPACK FOOTER //
// ./src/modules/leadership/mutations.js